module.exports = __webpack_public_path__ + "img/y9.prt.8ff26ef4.jpg";